import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import type { PDPStockLevel as PdpStockIndicatorSchema } from '@amplience/content-types/typings/c-pdp-stock-level';
import { TypographyStyles, colours, media, spacing } from '@storefront/lib-global/stylings';

const S = {
  StockIndicator: styled.span`
    color: ${colours.BLACK};
    margin-top: ${spacing.M};
    ${TypographyStyles.Body.Small.Regular}

    @media ${media.greaterThan('lg')} {
      margin-top: 23px;
    }
  `,
};

export type StockIndicatorProps = PdpStockIndicatorSchema & {
  inventory: number;
  isSubdomainOutlet: boolean;
};

export function StockIndicator({
  HighStockThreshold,
  LowStockThreshold,
  inventory,
  isSubdomainOutlet,
}: StockIndicatorProps) {
  const { t } = useTranslation(['lib-products-common']);

  if (!isSubdomainOutlet) return null;
  if (inventory === 0 || HighStockThreshold === 0 || LowStockThreshold === 0) return null;
  if (inventory > Number(LowStockThreshold) && inventory <= Number(HighStockThreshold)) {
    return (
      <S.StockIndicator data-testid="lowToHighStockIndicator" role="status">
        {t('pdp.low.to.high.stock.indicator', { inventory })}
      </S.StockIndicator>
    );
  }
  if (inventory <= Number(LowStockThreshold)) {
    return (
      <S.StockIndicator data-testid="lowStockIndicator" role="status">
        {t('pdp.low.stock.indicator', { inventory })}
      </S.StockIndicator>
    );
  }
  return null;
}
